module.exports = __webpack_public_path__ + "710629503c658723b6cad65979bebe52.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/dominik-kundel.jpg
// module id = 664
// module chunks = 0